import { render, staticRenderFns } from "./MainPagePanel3.vue?vue&type=template&id=b52a0e2c&scoped=true&"
import script from "./MainPagePanel3.vue?vue&type=script&lang=js&"
export * from "./MainPagePanel3.vue?vue&type=script&lang=js&"
import style0 from "./MainPagePanel3.vue?vue&type=style&index=0&id=b52a0e2c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b52a0e2c",
  null
  
)

export default component.exports